import { cn } from '@/lib/utils';
import React from 'react';

import { Label } from '@/components/ui/label';

interface SettingRowProps {
    label: string;
    description?: string;
    htmlFor?: string;
    compact?: boolean;
    wholeRowClickable?: boolean;
    children: React.ReactNode;
    className?: string;
}

export const SettingRow: React.FC<SettingRowProps> = ({
    label,
    description,
    htmlFor,
    compact = false,
    wholeRowClickable = false,
    children,
    className
}) => (
    <div
        className={cn(
            'flex flex-wrap justify-between items-center gap-x-8 gap-y-3 py-4 border-border border-b last:border-b-0',
            wholeRowClickable && 'relative',
            className
        )}
    >
        <div className="flex-1 min-w-48">
            <Label
                htmlFor={htmlFor}
                className={cn(
                    'font-medium text-foreground',
                    htmlFor && 'cursor-pointer',
                    wholeRowClickable && 'after:absolute after:inset-0',
                    compact
                        ? 'text-(length:--fs-subtitle) leading-(--lh-subtitle)'
                        : 'text-(length:--fs-title) leading-(--lh-title)'
                )}
            >
                {label}
            </Label>
            {description && (
                <p
                    className={cn(
                        'mt-0.5 text-muted-foreground',
                        compact
                            ? 'text-(length:--fs-caption) leading-(--lh-caption)'
                            : 'text-(length:--fs-title-compact) leading-(--lh-title-compact)'
                    )}
                >
                    {description}
                </p>
            )}
        </div>
        <div className={cn('shrink-0', wholeRowClickable && 'z-10 relative')}>
            {children}
        </div>
    </div>
);
